<template>
    <v-breadcrumbs :items="items" class="breadcrum">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
      <template v-slot:item="{ item }">
        <li class="v-breadcrumbs__item">
          <!-- Non-disabled crumbs with a route/href are real, clickable links; the current
               (disabled) crumb stays muted text. Explicit router-link guarantees navigation. -->
          <router-link
            v-if="item.to && !item.disabled"
            :to="item.to"
            :exact="item.exact"
            :replace="item.replace"
            class="crumb-link"
          >{{ item.text }}</router-link>
          <a
            v-else-if="item.href && !item.disabled"
            :href="item.href"
            class="crumb-link"
          >{{ item.text }}</a>
          <span v-else class="crumb-current">{{ item.text }}</span>
        </li>
      </template>
    </v-breadcrumbs>
</template>
<script>
export default {
    props: ['items']
}
</script>

<style  lang="scss" scoped>
    .breadcrum {
        // border-bottom: 1px solid;
        // border-color: $outline-color;
        padding: 18px 12px !important;
    }
    .crumb-link {
        color: $primary-color;
        text-decoration: none;
        cursor: pointer;
        font-size: 14px;
        &:hover { text-decoration: underline; }
    }
    .crumb-current {
        color: rgba(0, 0, 0, 0.6);
        font-size: 14px;
    }
</style>
